import { State } from './state'
import { Bundle, Flow } from '@/types/form/Apply'

export const SET_COUNTRY_LIST = (state: any, { countryList }: any) => {
    state.countryList = countryList
}

export const SET_LEAD = (state: any, { lead }: any) => {
    state.lead = lead
    window.sessionStorage.setItem('lead', JSON.stringify(lead))
}

export const SET_PLAN = (state: State, { plan }: any) => {
    state.plan = plan
    window.sessionStorage.setItem('selectedPlan', JSON.stringify(plan))
}

export const SET_BUNDLE = (state: State, bundle: Bundle) => {
    state.bundle = bundle
}

export const SET_FLOW = (state: State, flow: Flow) => {
    state.flow = flow
}
